export const completedReason =
{
    1: "device.status.completed",
    2: "device.status.complete-reason.stopped",
    3: "common.unknown"
}